export default __webpack_public_path__ + "static/media/dinnerHealthgenom.462ea801.svg";